module.exports = __webpack_public_path__ + "static/media/photo_7.cfeb37a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_7.jpg
// module id = 1640
// module chunks = 0